"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurfaceData = exports.TransactionType = exports.TransactionData = exports.TransactionType_Enum = void 0;
const timestamp_1 = require("../../../google/protobuf/timestamp");
const geo_1 = require("../../../core/geo");
const ipaddress_1 = require("../../../core/ipaddress");
const minimal_1 = __importDefault(require("protobufjs/minimal"));
/**
 * Enums indicating the type of Transaction. The type of the Transaction dictates the strings of the TIV Landing Page,
 * TIV Broadcasts contents (notification, Email, SMS), and, if applicable, business rules for the TIV
 */
var TransactionType_Enum;
(function (TransactionType_Enum) {
    /** UNSET - Default enum value */
    TransactionType_Enum[TransactionType_Enum["UNSET"] = 0] = "UNSET";
    /** SIGN_IN - Sign-In Transaction */
    TransactionType_Enum[TransactionType_Enum["SIGN_IN"] = 1] = "SIGN_IN";
    /** SIGN_UP - Sign-up Transaction */
    TransactionType_Enum[TransactionType_Enum["SIGN_UP"] = 2] = "SIGN_UP";
    /**
     * TRANSACTION_REVERT_PHONE_UPDATE - Phone Enrollment Transaction for Transaction Revert. This TransactionType should only be used by `auth-trs`
     * when after a passive/active "Change Phone" Transaction succeeds.
     */
    TransactionType_Enum[TransactionType_Enum["TRANSACTION_REVERT_PHONE_UPDATE"] = 3] = "TRANSACTION_REVERT_PHONE_UPDATE";
    /**
     * TRANSACTION_REVERT_EMAIL_UPDATE - Email Enrollment Transaction for Transaction Revert. This TransactionType should only be used by `auth-trs`
     * when after an active "Change Email" Transaction succeeds.
     */
    TransactionType_Enum[TransactionType_Enum["TRANSACTION_REVERT_EMAIL_UPDATE"] = 4] = "TRANSACTION_REVERT_EMAIL_UPDATE";
    /** NOTIFICATION_CAMPAIGN - "Notification Campaign" is a system initiated Transaction associated to a campaign (e.g. Friend Add SMS Campaign) */
    TransactionType_Enum[TransactionType_Enum["NOTIFICATION_CAMPAIGN"] = 5] = "NOTIFICATION_CAMPAIGN";
    /** TRANSACTION_REVERT_PASSKEY_ADDED - Passkey added for the account */
    TransactionType_Enum[TransactionType_Enum["TRANSACTION_REVERT_PASSKEY_ADDED"] = 6] = "TRANSACTION_REVERT_PASSKEY_ADDED";
    /** TRANSACTION_REVERT_PASSKEY_REMOVED - Passkey removed from the account */
    TransactionType_Enum[TransactionType_Enum["TRANSACTION_REVERT_PASSKEY_REMOVED"] = 7] = "TRANSACTION_REVERT_PASSKEY_REMOVED";
    TransactionType_Enum[TransactionType_Enum["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(TransactionType_Enum = exports.TransactionType_Enum || (exports.TransactionType_Enum = {}));
function createBaseTransactionData() {
    return {
        transactionId: "",
        sessionId: "",
        type: 0,
        geoHeader: undefined,
        surfaceData: undefined,
        timestamp: undefined,
        ip: undefined,
    };
}
exports.TransactionData = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.transactionId !== "") {
            writer.uint32(10).string(message.transactionId);
        }
        if (message.sessionId !== "") {
            writer.uint32(18).string(message.sessionId);
        }
        if (message.type !== 0) {
            writer.uint32(24).int32(message.type);
        }
        if (message.geoHeader !== undefined) {
            geo_1.GeoHeader.encode(message.geoHeader, writer.uint32(34).fork()).ldelim();
        }
        if (message.surfaceData !== undefined) {
            exports.SurfaceData.encode(message.surfaceData, writer.uint32(42).fork()).ldelim();
        }
        if (message.timestamp !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.timestamp), writer.uint32(50).fork()).ldelim();
        }
        if (message.ip !== undefined) {
            ipaddress_1.IPAddress.encode(message.ip, writer.uint32(58).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTransactionData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.transactionId = reader.string();
                    break;
                case 2:
                    message.sessionId = reader.string();
                    break;
                case 3:
                    message.type = reader.int32();
                    break;
                case 4:
                    message.geoHeader = geo_1.GeoHeader.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.surfaceData = exports.SurfaceData.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.timestamp = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    break;
                case 7:
                    message.ip = ipaddress_1.IPAddress.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseTransactionData();
        message.transactionId = object.transactionId ?? "";
        message.sessionId = object.sessionId ?? "";
        message.type = object.type ?? 0;
        message.geoHeader =
            object.geoHeader !== undefined && object.geoHeader !== null
                ? geo_1.GeoHeader.fromPartial(object.geoHeader)
                : undefined;
        message.surfaceData =
            object.surfaceData !== undefined && object.surfaceData !== null
                ? exports.SurfaceData.fromPartial(object.surfaceData)
                : undefined;
        message.timestamp = object.timestamp ?? undefined;
        message.ip =
            object.ip !== undefined && object.ip !== null
                ? ipaddress_1.IPAddress.fromPartial(object.ip)
                : undefined;
        return message;
    },
};
function createBaseTransactionType() {
    return {};
}
exports.TransactionType = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTransactionType();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(_) {
        const message = createBaseTransactionType();
        return message;
    },
};
function createBaseSurfaceData() {
    return { surface: 0, userAgent: "", device: "", os: "", browser: "" };
}
exports.SurfaceData = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.surface !== 0) {
            writer.uint32(8).int32(message.surface);
        }
        if (message.userAgent !== "") {
            writer.uint32(18).string(message.userAgent);
        }
        if (message.device !== "") {
            writer.uint32(26).string(message.device);
        }
        if (message.os !== "") {
            writer.uint32(34).string(message.os);
        }
        if (message.browser !== "") {
            writer.uint32(42).string(message.browser);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSurfaceData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.surface = reader.int32();
                    break;
                case 2:
                    message.userAgent = reader.string();
                    break;
                case 3:
                    message.device = reader.string();
                    break;
                case 4:
                    message.os = reader.string();
                    break;
                case 5:
                    message.browser = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseSurfaceData();
        message.surface = object.surface ?? 0;
        message.userAgent = object.userAgent ?? "";
        message.device = object.device ?? "";
        message.os = object.os ?? "";
        message.browser = object.browser ?? "";
        return message;
    },
};
function toTimestamp(date) {
    const seconds = Math.trunc(date.getTime() / 1_000).toString();
    const nanos = (date.getTime() % 1_000) * 1_000_000;
    return { seconds, nanos };
}
function fromTimestamp(t) {
    let millis = Number(t.seconds) * 1_000;
    millis += t.nanos / 1_000_000;
    return new Date(millis);
}
//# sourceMappingURL=transaction.js.map